import { buildDayForBooking, ProcessTypes, UserProfile } from 'fitbeat.gym-core';
import { Gym, GymTypes } from 'fitbeat.models';
import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { enabledFeaturesSelector, PaywallPage } from '../../auth';
import { getNextBookingStep, setupInstantWorkout } from '../../Bookings';
import { getBookingSlotsAndRecommendedSettings } from '../../Bookings/actions';
import { Button, ButtonSize, ButtonTypes } from '../../components';
import { openPaywallModalAction } from '../../payments/redux/payments-actions';
import Theme from '../../theme';
import { toggleBookingsModal } from '../../ui';
import { clearDeepLinkParams } from '../../utils/notifications/actions';

interface IProps {
  userProfile: UserProfile;
  buttonTitle: string;
  overrideButtonSize: any;
  buttonType: any;
  clearDeepLinkParams: any;
  toggleBookingsModal: any;
  getNextBookingStep: any;
  setupInstantWorkout: any;
  getBookingSlotsAndRecommendedSettings: any;
  workoutSessionService: any;
  overrideButtonTextStyle: any;
  containerStyle: any;
  navigation: any;
  homeGym: Gym;
  openPaywallModal(): void;
}

class StartWorkoutButtonComponent extends React.Component<IProps, any> {
  public render() {
    return (
      <Button
          title={this.props.buttonTitle}
          size={this.props.overrideButtonSize || ButtonSize.NORMAL}
          isLoading={false}
          fontColor={Theme.BLACK}
          onPress={this.startBookingProcess}
          buttonType={this.props.buttonType || ButtonTypes.NORMAL}
          overrideFontStyles={this.props.overrideButtonTextStyle || {}}
          containerStyle={this.props.containerStyle}
        />
      );
  }

  private startBookingProcess = async () => {
    const { userProfile } = this.props;

    if (!UserProfile.hasActivePlan(userProfile)) {
      this.props.openPaywallModal();
      this.props.clearDeepLinkParams([ 'workoutInviteStartTime' ]);
      return;
    }
    const { homeGym } = this.props;
    this.props.toggleBookingsModal(false);
    const day = buildDayForBooking(moment(), true);
    this.props.setupInstantWorkout(homeGym.name, day);
    this.props.getBookingSlotsAndRecommendedSettings(
      this.props.workoutSessionService,
      day,
      userProfile,
      homeGym);
    this.props.getNextBookingStep(userProfile, ProcessTypes.StartInstant, []);
    this.props.toggleBookingsModal(true);
  }
}

const mapStateToProps = (state) => {
  const enabledFeatures = enabledFeaturesSelector(state);
  return {
    homeGym: enabledFeatures.workout.homeGym,
  };
};

const mapDispatchToProps = (dispatch: any): Partial<IProps> => {
  return {
    getNextBookingStep: (userProfile, processType, options) =>
      dispatch(getNextBookingStep(userProfile, processType, options)),
    clearDeepLinkParams: (params: string[]) => dispatch(clearDeepLinkParams(params)),
    toggleBookingsModal: (visible: boolean) => dispatch(toggleBookingsModal(visible)),
    setupInstantWorkout: (gymName: string, day: any) => dispatch(setupInstantWorkout(gymName, day)),
    getBookingSlotsAndRecommendedSettings: (workoutSessionService, day, userProfile: UserProfile, gym: Gym) =>
      dispatch(getBookingSlotsAndRecommendedSettings(workoutSessionService, day, userProfile, gym)),
    openPaywallModal: () => dispatch(openPaywallModalAction(PaywallPage.Workout)),
  };
};

export const StartWorkoutButton = connect(
  mapStateToProps,
  mapDispatchToProps)(StartWorkoutButtonComponent);
